import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import posthog from 'posthog-js';

@Injectable()
export class SalesPipelineGuard {
	public canActivate(): boolean {
		if (environment.posthog) {
			return true; // posthog.isFeatureEnabled('sales_pipeline');
		}
	}
}
